import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {invoice_lange} from "../../language/invoice";
import Swal from 'sweetalert2';
import { MyserviceService } from '../../provider/myservice.service';
import * as moment from 'moment';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-clear-payment',
  templateUrl: './clear-payment.component.html',
  styleUrls: ['./clear-payment.component.scss']
})
export class ClearPaymentComponent implements OnInit {
  actions=[
    {id:0,action_type:{TH:"แสดงรายการการชำระ",EN:"Invoice Data"}},
    {id:1,action_type:{TH:"ชำระเงิน",EN:"Pay"}},

  ]
  paybills:any;
  all_paybill:any;
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  isLoading=true;
  action=this.actions[0];
  paybill:any;
  vat_price=0;
  payments:any;
  submitted=false;
  paytype="";
  sum_total=0;
  sum_fee=0;
  users:any;
  // submitted:false;
  start_date=moment().format("YYYY-MM-DD");
  end_date=moment().format("YYYY-MM-DD");
  user_id="";
  constructor(
    private route:ActivatedRoute,
    router:Router,
    private localeService : BsLocaleService,
    private service:MyserviceService) 
    { }

  ngOnInit() {
    // this.refreshData();
    this.service.postData({topic:'--',},"get_user").then((result:any)=>{
      this.users=result.data;
    },err=>{
      window.location.href=this.service.start_host
    })
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=invoice_lange[this.lang];
        this.localeService.use(this.lang.toLowerCase());
      }else{
        this.language=invoice_lange[this.lang];
        localStorage.setItem('lang',this.lang);
        this.localeService.use(params['lang'].toLowerCase());
      }
   });
  }
  save(){
   if(this.paybills.length>0){
    var post_data=this.paybills.map((item)=>{
      return {bill_id:item.bill_id,invoice_id:item.invoice_id}
    });
    this.service.postData(post_data,"invoice/update-paid").then((result)=>{
      Swal.fire({
        title: this.language.saved,
        text: '',
        type: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        timer:2000
      }).then((result)=>{
        this.refreshData();
      });

    },err=>{
      window.location.href=this.service.start_host
    })
   }
  }
  onSearchFee_type(event){
    this.paybills=this.all_paybill.filter((item)=>{
      return compare(item.bill_id)||
      compare(item.fee_id)||
      compare(item.fee_description)||
      compare(item.customer_id)||
      compare(item.customer_name)||
      compare(item.user_id)||
      compare(item.create_datetime)||
      compare(item.due_date);

    })
    function compare(type){
      return type.toLowerCase().indexOf(event.target.value.toLowerCase())>-1;
    }
  }
  search(){
    this.submitted=true;
    if(this.user_id!=""&&this.start_date!=""&&this.end_date!=""){
      this.isLoading=true;
      // this.submitted=true;
      // this.isLoading=false;
      // alert(this.user_id);
      this.service.postData({user_id:this.user_id,start_date:this.start_date,end_date:this.end_date},"invoice/get-bill-paid").then((result:any)=>{
        //console.log(result);
        this.isLoading=false;
        this.sum_total=0;
        this.sum_fee=0;
        this.all_paybill=result.data.map((item)=>{
          var res:any;
          res=item;
          this.sum_total+=parseInt(item.total_price);
          this.sum_fee+=parseInt(item.fee_price)
          res.createDate=moment(item.create_datetime).format("DD/MM/YYYY HH:mm:ss");
          res.dueDate=moment(item.due_date).format("DD/MM/YYYY HH:mm:ss");
          res.pay_datetime=moment(res.pay_datetime).format("DD/MM/YYYY HH:mm:ss");
          // res.pay_datetime=moment(res.pay_datetime).format("DD/MM/YYYY");

          // res.pay_datetime=this.formatDate(res.pay_datetime)+" "+res.pay_datetime.toISOString().substring(11,19);
          return res;
        });
        this.paybills=this.all_paybill;
         this.submitted=true;
      },(err)=>{
        //console.log(err);
      })
    }
  }
  refreshData(){
    this.submitted=false;
    this.action=this.actions[0];
    this.isLoading=true;
    this.service.postData({},"bill/get").then((result:any)=>{
      //console.log(result);
      this.isLoading=false;
      this.all_paybill=result.data.filter((item)=>{
        var res:any;
        res=item;
        res.createDate=this.formatDate(new Date(item.create_datetime));
        res.dueDate=this.formatDate(new Date(item.due_date));
        res.pay_datetime=new Date(res.pay_datetime);
        res.pay_datetime=new Date(res.pay_datetime.setHours(res.pay_datetime.getHours()+7));
        res.pay_datetime=this.formatDate(res.pay_datetime)+" "+res.pay_datetime.toISOString().substring(11,19);
        return res;
      });
      this.paybills=this.all_paybill;
    },(err)=>{
      //console.log(err);
    })
  }

  formatDate(date) {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var hour=date.getHours();
    var min=date.getMinutes();
    var sec=date.getSeconds();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }
  delete(bill){
    Swal.fire({
      title: this.language.confirm_delete,
      text: this.language.warining_delete,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close
    }).then((result) => {
      if (result.value) {

        this.service.postData({bill_id:bill.bill_id},"invoice/cancel-invoice").then(result=>{
          this.isLoading=false;
          Swal.fire({
            title: this.language.deleted,
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer:2000
          }).then((result) => {
            this.refreshData();
          })
        },err=>{
          window.location.href=this.service.start_host
          this.isLoading=false;
        })
      }
    });
  }
  update(bill){
    this.paybill=bill;
    this.action=this.actions[1];
    this.isLoading=true;
    this.vat_price=(1-parseFloat(bill.vat))*parseFloat(bill.total_price);
    //  this.isLoading=true;
    this.service.postData({},"payment-type/get").then((result:any)=>{
      this.payments=result.data;
      this.isLoading=false;

    },err=>{
      window.location.href=this.service.start_host
    })
  }
  back(){
    this.refreshData();
  }

}
